const initialState = () => ({
  isEdit: "",
  customer_form: {
    NEWCUSTOMER_ID: "",
    CUSTOMER_ID: "",
    BILL_ID: "",
    CONTACT_TYPE: "",
    CUSTOMER_TAX_ID: "",
    CUSTOMER_NAME: "",
    CUSTOMER_TYPE: "",
    CUSTOMER_GROUP: "",
    CUSTOMER_ADDRESS: "",
    CUSTOMER_BRANCH: "",
    CUSTOMER_BRANCH_NAME: "",
    ORGANIZATION_NAME: "",
    CUSTOMER_PROVINCE: "",
    CUSTOMER_DISTRICT: "",
    CUSTOMER_SUBDISTRICT: "",
    CUSTOMER_TYPE_OTHER: "",
    CUSTOMER_ZIPCODE: "",
    PROVIDER_NAME: "",
    PROVIDER_POSITION: "",
    PROVIDER_PHONE: "",
    PROVIDER_NEWPHONE: "",
    PROVIDER_EMAIL: "",
    PROVIDER_LINE_ID: "",
    PROVIDER_FACEBOOK: "",
    CONTRACT_CATEGORY: "",
    LATS: "",
    LONGS: "",
    LINE_USERID: "",
    CONFIRM_NEW_CUS: "",
    CUSTOMER_NOT_ACTTIVE: "",
    COLLECT_DATE: new Date(),
    CONTRACT_START_DATE: new Date(),
    CONTRACT_PERIOD: "",
    CONTRACT_END_DATE: null,
    ISVAT: false,
    ISVAT2: false,
    VAT_VALUE: "",
    VAT_VALUE2: "",
    CAR_NUMBER: "",
    COLLECT_ZONE: "",
    DEPOSIT_DATE: null,
    DEPOSIT_VALUE: 0,
    BORROW_DATE: null,
    BORROW_VALUE: 0,
    ISDEPOSIT:false,
    ISBORROW:false,
    NOTE: "",
    MEMO: "",
    STATUS: "",
  },
  PRODUCT_LIST: [
    {
      PRO_ID:0,
      PID: 0,
      QID: "",
      NAME: "",
      DETAIL: "",
      AMOUT: 1,
      UNIT: "",
      PRICE: 0,
      TOTAL_PRICE: 0,
    },
  ],
  DAYS: [],
});

const state = initialState();

const getters = {
  GET_CUSTOMER: (state) => state.customer_form,
  GET_DAYS: (state) => state.DAYS,
  GET_SE_DATE: (state) => state.SE_DATE,
  GET_PRODUCT: (state) => state.PRODUCT_LIST,
  IS_EDIT: (state) => state.isEdit,
};
const mutations = {
  SET_IS_EDIT(state, data) {
    state.isEdit = data;
  },
  SET_ALL_ELEMENT(state, data) {
    state.customer_form = Object.assign({}, data);
  },
  MERGE_ALL_ELEMENT(state, data) {
    let object1 = state.customer_form
    state.customer_form = Object.assign(object1, data);
  },
  SET_ELEMENT(state, data) {
    state.customer_form[data.key] = data.value;
  },
  SET_PRODUCT_LIST(state, data) {
    state.PRODUCT_LIST = data;
  },
  SET_DAYS(state, data) {
    state.DAYS = data
  },
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  DT_reset({ commit }) {
    commit("RESET");
  },
  initDays(context) {
    const days = [
      "อาทิตย์",
      "จันทร์",
      "อังคาร",
      "พุธ",
      "พฤหัสบดี",
      "ศุกร์",
      "เสาร์",
    ];
    let data = [];
    for (let i = 0; i < days.length; i++) {
      data.push({
        CUSTOMER_ID: null,
        DAYS: days[i],
        HOURS_START: "HH:mm",
        HOURS_END: "HH:mm",
        TRANSPORT_TIME: "HH:mm",
        ISOPEN: false,
        TRANSPORT: false
      })
    }

    context.commit("SET_DAYS", data);
  },
  resetTranHour(context, items) {
    let data = context.state.DAYS
    data[items].TRANSPORT_TIME = "HH:mm"
    context.commit('SET_DAYS', data)
  },
  addTran(context, items) {
    let data = items
    for (let i = 0; i < data.length; i++) {
      data[i].TRANSPORT_TIME = "HH:mm"
    }
    context.commit('SET_DAYS', data)
  },
  resetHour(context, items) {
    let data = context.state.DAYS
    data[items].HOURS_START = "HH:mm"
    data[items].HOURS_END = "HH:mm"
    context.commit('SET_DAYS', data)
  },
  reset_product_list(context, items) {
    context.commit("SET_PRODUCT_LIST", [
      {
        INDEX: 0,
        NAME: "",
        DETAIL: "",
        AMOUT: 1,
        UNIT: "",
        PRICE: 0,
        TOTAL_PRICE: 0,
      },
    ]);
  },
  remove_product_list(context, items) {
    let data = context.state.PRODUCT_LIST;
    const index = data.indexOf(items);
    data.splice(index, 1);
    context.commit("SET_PRODUCT_LIST", data);
  },
  add_product_list(context, items) {
    let data = context.state.PRODUCT_LIST;
    data.push(items);
    data[data.length - 1].INDEX = parseInt(data.length) - 1;
    context.commit("SET_PRODUCT_LIST", data);
  },
  reset({ commit }) {
    commit("RESET");
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
